import './InvoiceSettingsView.scss?global'

import Smartphones from 'User/Settings/views/InvoiceSettingsView/containers/Smartphones'
import Tablets from 'User/Settings/views/InvoiceSettingsView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const InvoiceSettingsView = getCurrentDeviceView(Smartphones, Tablets)

export default InvoiceSettingsView
